// Imports
import ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ from "../../../node_modules/html-loader/dist/runtime/getUrl.js";
var ___HTML_LOADER_IMPORT_0___ = new URL("../../img/logo_apps.svg", import.meta.url);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<img style=\"margin:34px;position:absolute\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" height=\"auto\" width=\"180px\">";
// Exports
export default code;